const renderJobHistory = (jobHistoryData) => {
	let html = '';

	jobHistoryData.forEach((history) => {
		html += `
            <li class="job-history__list-item">
                <strong class="job-history__action">${history.action}.</strong>
                <div class="job-history__info">
                    <span>${history.user_first_name} ${history.user_last_name}</span> on ${history.date_verbose} at ${history.time_verbose.toLowerCase()}
                </div>`;


		if (history.message) {
			html += `<a
                    class="btn btn--plain collapsed"
                    data-bs-toggle="collapse"
                    href="#collapse${history.id}"
                    role="button"
                    aria-expanded="false"
                    aria-controls="collapse{{ history.id }}"
            >
                View Details
            </a>
            <div class="collapse" id="collapse${history.id}">
                <div class="card card-body">
                    ${history.message}
                </div>
            </div>`
		}

		html += '</li>';

	});

	return html;
};

export default renderJobHistory;
